import { Component, OnInit } from '@angular/core';
import {PayeeCustomer} from "../../shared/model/payee_customer";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {validateEmail} from "../../shared/validators/validate-email";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";


@Component({
  selector: 'app-invoice-email-edit',
  templateUrl: './invoice-email-edit.component.html',
  styleUrls: ['./invoice-email-edit.component.css']
})
export class InvoiceEmailEditComponent implements OnInit {
   customer:PayeeCustomer;
   form: FormGroup;


  constructor(
    private fb: FormBuilder,
    private router:Router,
    private route: ActivatedRoute,
    private localStripeService: LocalStripeService,
    public modal: Modal,

  ) {

    route.data
      .subscribe(
        (data:{customer:PayeeCustomer}) =>
        {
          this.customer = data.customer;
          // console.log(this.customer);
        }
      )
  }

  ngOnInit() {

    this.form = this.fb.group({
      email:['',[Validators.required, validateEmail]],

    });

    this.initializeForm(this.customer);

  }

  initializeForm(customer: PayeeCustomer) {
    // console.info("Passed Source!!!!!!");
    // console.log(customer);
    this.form.controls["email"].setValue(customer.email);


  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  cancel() {
    let restaurantId = this.customer.restaurant_id;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});
  }

  save(form) {
    // console.log("Showing Form Values ");
    // console.log(form);
    if (form.invalid){
      this.showErrors();
    } else {
      this.updateCustomerEmail(this.customer.id,this.form.value.email);

    }
  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }

  reset() {
    this.form.reset();

  }


  private updateCustomerEmail(id: string, email) {
    const customerEmail$ = this.localStripeService.updateCustomerEmail(this.customer.id,this.form.value.email);
    customerEmail$
      .subscribe(()=>{
      this.navigateToAccountingPage();
      }
      ,err => this.messageIt('Error Updating Email', err)
      )

  }

  private navigateToAccountingPage() {
    let restaurantId = this.customer.restaurant_id;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});

  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }





}



// WEBPACK FOOTER //
// ./src/app/invoice/invoice-email-edit/invoice-email-edit.component.ts